export enum ECardPurchaseType {
  ON_LOAD_BY_REQUEST = 'ON_LOAD_BY_REQUEST',
  ON_DEMAND = 'ON_DEMAND',
  DEFAULT = 'DEFAULT'
}
